<template>
  <BaseDialog
        :showDialog="showDialog"
        headline="lang_PUBLISHING_STATEMENTS_DIALOG_CAPTION_ARCHIVING"
        :close="closeDialog"
        :alvqa="alvqa"
        maxCardHeight="600"
        maxDialogWidth="700"
    >
        <template v-slot:dialogText>
            <v-container fluid>
                <v-row v-if="checkIfSomeRowsNotArchivable">
                    <v-col :alvqa="alvqa + 'warning-text'" class="text-center">
                        {{ $t('lang_LABEL_STATEMENTS_ARCHIVING_WARNING_NO_RESULTS')}} <br /> <br />
                        {{ getNameOfNotNotArchivableStatements() }}
                    </v-col>
                </v-row>
                <v-row v-if="checkIfNoneAreArchivable">
                    <v-col :alvqa="alvqa + 'close-text'" class="text-center">
                        {{ $t('lang_GENERAL_DIALOG_TEXT_CLOSE_DIALOG') }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col 
                        v-if="!checkIfNoneAreArchivable"
                        :alvqa="alvqa + '-text'" 

                        v-html="getDialogText"
                    ></v-col>
                </v-row>
                <v-row v-if="!checkIfNoneAreArchivable">
                    <v-col>
                        <v-checkbox
                            v-model="doNotAddCreditNumber"
                            :disabled="archivingIsInProgress"
                            color="generalCheckbox"
                            class="mt-0"
                            hide-details
                            :alvqa="alvqa + '-checkbox-do-not-add-credit-number'"
                        >
                            <template v-slot:label>
                                <span
                                    class="black--text pt-1"
                                    :alvqa="alvqa + '-checkbox-do-not-add-credit-number-text'"
                                >{{ $t('lang_STATEMENTS_ARCHIVING_DO_NOT_ADD_CREDIT_NUMBER') }}</span>
                            </template>
                        </v-checkbox>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-text-field
                            v-model="addTag"
                            :label="$t('lang_GENERAL_CAPTION_ADD_TAG')"
                            hide-details
                            clearable
                            :alvqa="alvqa + '-textfield-add-tag'"
                    ></v-text-field>
                    </v-col>
                </v-row>
                <v-row v-if="showCcfField">
                    <v-col cols="6">
                        <BaseEditPageTextField
                            :context="context"
                            field="Ccf"
                            :label="$t('lang_GENERAL_CAPTION_CONVERSION_FACTOR')"
                            :withMargin="false"
                            :alvqa="alvqa + '-textfield-currency-conversion-factor'"
                            :suffix="targetCurrency"
                            rules="required"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </template>
            <template v-slot:dialogActions>
                <v-container fluid>
                    <v-row>
                        <v-spacer />
                        <v-col class="d-flex justify-end pl-0 pt-0" align-self="center">
                            <v-progress-circular v-if="archivingIsInProgress"
                                class="mr-5" 
                                :alvqa="alvqa + '-progress-bar'"
                                indeterminate
                                color="dialogProgressbar"
                            ></v-progress-circular>
                            <BaseButton 
                                :disabled="isArchiveDisabled"
                                :label="getButtonLabel"
                                @click="archive"
                                :alvqa="alvqa + '-button-archiving-' + getTypeOfArchiving()"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </template>
    </BaseDialog>
</template>

<script>

import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'

export default {
    name:'PublishingStatementsArchivingDialog',

    data() {
        return {
            doNotAddCreditNumber: false,
            alvqa: "publishing-statements-archiving-dialog",
            context: 'PublishingStatementsArchiving'
        }
    },

    components: {
        BaseDialog,
        BaseButton,
        BaseEditPageTextField,
    },

    computed: {
        isCcfEntered() {
            const ccf = this.$store.getters.getPublishingStatementsArchivingDetailsCcf
            return ccf !== null && ccf !== ""
        },
        isArchiveDisabled() {
            return this.checkIfNoneAreArchivable || this.archivingIsInProgress || (this.showCcfField && !this.isCcfEntered);
        },
        targetCurrency() { return this.$store.getters.getPublishingStatementsArchivingTargetCurrency || "" },
        showCcfField() { return this.$store.getters.getPublishingStatementsArchivingShowCcfField },
        addTag: {
            get() { return this.$store.getters.getAddTag },
            set(tag) { 
                if (tag != null) {
                    this.$store.commit('setAddTag', tag.replace(/\s/g, ''))
                } else {
                    this.$store.commit('setAddTag', null)
                }
            }
        },
        showDialog: {
            get() { return this.$store.getters.getShowPublishingStatementsArchivingDialog },
            set(show) { this.$store.commit('setShowPublishingStatementsArchivingDialog', show) }
        },
        archivingIsInProgress(){
            return this.$store.getters.getPublishingStatementsArchivingInProgress
        },
        getButtonLabel() {
            let actionValue = this.$store.getters.getSelectedPublishingStatementsAction
            let langConst = ''

            if(actionValue === 'archiveWithForwarded') langConst = 'lang_GENERAL_CAPTION_ARCHIVE_WITH_CARRY_FORWARD'
            if(actionValue === 'archiveWithoutForwarded') langConst = 'lang_GENERAL_CAPTION_ARCHIVE_WITHOUT_CARRY_FORWARD'

            return langConst
        },
        getDialogText() {
            let dialogText = this.$t('lang_LABEL_STATEMENTS_ARCHIVING_DIALOG_TEXT')

            dialogText = dialogText.replace(/<archiving>/gi, matched => {
                return {
                    '<archiving>': this.$t(this.getButtonLabel)
                }[matched]
            })

            return dialogText
        },

        checkIfNoneAreArchivable() {
            let selectedStatements = this.getSelectedStatementsDetails()
            return selectedStatements.every(statement => statement.archivable === 'no')
        },
        checkIfSomeRowsNotArchivable() {
            let selectedStatements = this.getSelectedStatementsDetails()
            return selectedStatements.some(statement => statement.archivable === 'no')
        },
    },

    watch: {
        showDialog(show) {
            if (show) this.doNotAddCreditNumber = false
        },
    },
    methods: {
        closeDialog() {
            this.showDialog = false
            this.$store.commit('setSelectedPublishingStatementsAction', [])
            this.$store.commit('setPublishingStatementsArchivingDetailsCcf', null)
            this.$store.commit('setAddTag', null)
        },
        archive() {
            this.$store.dispatch('archivePublishingStatements', { addCreditNumber: !this.doNotAddCreditNumber })
        },

        getSelectedStatementsDetails() {
            let selectedStatementsAlvIds = this.$store.getters.getSelectedPublishingStatements
            let allStatements = this.$store.getters.getPublishingStatements
            let statementsDetailsArray = []

            selectedStatementsAlvIds.forEach(alvId => {
                let match = allStatements.find(statement => {
                    return alvId === statement.alvId
                })

                statementsDetailsArray.push(match)
            })
            return statementsDetailsArray
        },

        getNameOfNotNotArchivableStatements() {
            let selectedStatements = this.getSelectedStatementsDetails()
            let namesOfNotArchivableStatements = []

            selectedStatements.forEach(statement => {
                if(statement.archivable === 'no') { 
                    namesOfNotArchivableStatements.push(statement.name)
                }
            }) 

            return namesOfNotArchivableStatements.join(', ')
        },

        getTypeOfArchiving() {
            if (this.$store.getters.getSelectedPublishingStatementsAction == "archiveWithForwarded")
                return "with-carry-forward"
            else
                return "without-carry-forward"
        }
    },
}
</script>
